/* Pincode delivery widget (per-instance behaviour).

   CHANGED: this script used to be inlined by snippets/pincode.liquid inside every
   widget, 19 KB of JavaScript in the HTML of every product page, parsed on each visit
   and never cached. It is now one deferred asset. The code is the same; what changed
   is the wrapper: instead of finding its own root through document.currentScript, the
   file initialises every [data-pincode-widget] on the page (and any the theme editor
   adds later) exactly once. Shared data loading, caching and detection still live in
   snippets/pincode-engine.liquid (window.YHLPincode).

   The snippet keeps a few inline lines that restore a cached "Deliver to" row before
   first paint, so returning visitors do not see the input flash before this file runs. */
(function () {
  'use strict';
  if (window._yhlPincodeWidget) return;
  window._yhlPincodeWidget = true;

  'use strict';

  var CONFIG = {

    /* CHANGED: DETECT_ON_LOAD, DATA_URL, CACHE_KEY, CACHE_TS_KEY, CACHE_TTL_MS and
       GEO_TIMEOUT_MS were removed from this block. Since the refactor into
       snippets/pincode-engine.liquid the engine owns data loading, caching and
       detection, and nothing in this file read those keys. DATA_URL also pointed at
       pincode-data.json, which does not exist in assets; the engine loads
       pincode-data.csv. Only the keys this widget still reads remain. */

    /* When a pincode was GUESSED from IP rather than typed, should we show
       "Non serviceable"? Leave false. IP geo in India is city-level, so a
       false negative tells a payable customer we cannot deliver to them. */
    SHOW_NEGATIVE_ON_AUTO: false,

    /* Client-side logging to the Apps Script sheet. The endpoint below is
       public in this file, so anyone can write to it. Manual entries only
       when enabled, and deduped per page. */
    ENABLE_SHEET_LOGGING: false,

    WEBHOOK_URL:   'https://script.google.com/macros/s/AKfycbxRDm__QRrAyaEsj1WKCeIaKuUiyZBL6i6oNKnS1f9kkEqKDCi-ziqxR01NLjV4TMaW/exec',

    BROWSER_ID_KEY:     'pincode_browser_id',
    LOCATION_CACHE_KEY: 'pincode_location_cache_v4',  /* must match LOC_KEY in pincode-engine */
    LOCATION_CACHE_TTL: 604800000,       /* detected location: 7 days.
                                            This is the main quota saver. */

    ZAPPR_START_HOUR:  10,
    ZAPPR_END_HOUR:    18,
    ZAPPR_EARLY_START:  6
  };

  function initWidget(wrapper) {
    if (wrapper.hasAttribute('data-pincode-bound')) return;
    wrapper.setAttribute('data-pincode-bound', '');
    var sentKeys = {};
    var root       = wrapper.querySelector('[data-pincode-root]');
    if (!root) { return; }

    var el = {
      input:         root.querySelector('[data-pincode-input]'),
      btn:           root.querySelector('[data-pincode-button]'),
      msg:           root.querySelector('[data-pincode-message]'),
      locationBadge: root.querySelector('[data-location-badge]'),
      locationText:  root.querySelector('[data-location-text]'),
      inputWrap:     root.querySelector('.pc-input-wrap')
    };
    if (!el.input || !el.btn || !el.msg) { return; }

    var isAutoDetected = false;
    var lastChecked    = '';

    var elDeliver = {
      row:      wrapper.querySelector('[data-deliver-row]'),
      location: wrapper.querySelector('[data-deliver-location]'),
      date:     wrapper.querySelector('[data-deliver-date]'),
      changeBtn:wrapper.querySelector('[data-change-btn]')
    };

    function calcDeliveryDate(addBusinessDays) {
      var now = new Date();
      var ist = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + 5.5 * 3600000);
      if (addBusinessDays === 0) {
        var days0 = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var m0 = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return days0[ist.getDay()] + ', ' + ist.getDate() + ' ' + m0[ist.getMonth()];
      }
      var d = new Date(ist);
      var added = 0;
      while (added < addBusinessDays) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) { added++; }
      }
      var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      return days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
    }

    function showDeliverRow(locationLabel, deliveryDate) {
      if (!elDeliver.row) { return; }
      elDeliver.location.textContent = locationLabel;
      elDeliver.date.textContent = deliveryDate;
      elDeliver.row.classList.add('visible');
      root.style.display = 'none';
      /* Collapse the theme block-item wrapper so it doesn't add spacing */
      var blockItem = wrapper.closest('.product-info__block-item');
      if (blockItem) {
        blockItem.style.marginTop    = '0';
        blockItem.style.marginBottom = '0';
        blockItem.style.paddingTop   = '0';
        blockItem.style.paddingBottom= '0';
      }
    }

    function hideDeliverRow() {
      if (!elDeliver.row) { return; }
      elDeliver.row.classList.remove('visible');
      root.style.display = '';
      var blockItem = wrapper.closest('.product-info__block-item');
      if (blockItem) {
        blockItem.style.marginTop    = '';
        blockItem.style.marginBottom = '';
        blockItem.style.paddingTop   = '';
        blockItem.style.paddingBottom= '';
      }
    }

    if (elDeliver.changeBtn) {
      elDeliver.changeBtn.addEventListener('click', function () {
        hideDeliverRow();
        clearAutoLocation();
        el.input.focus();
      });
    }

    /* ── utilities ──────────────────────────────────────────────── */
    var utils = {
      getBrowserId: function () {
        try {
          var id = localStorage.getItem(CONFIG.BROWSER_ID_KEY);
          if (!id) {
            id = 'user_' + Math.random().toString(36).substr(2, 9) + Date.now();
            localStorage.setItem(CONFIG.BROWSER_ID_KEY, id);
          }
          return id;
        } catch (e) { return 'user_unknown'; }
      },
      isMaharashtra: function (pin) {
        var p = parseInt(pin, 10);
        return p >= 400000 && p <= 445999;
      },
      isIndianPin: function (pin) {
        var p = parseInt(pin, 10);
        return pin.length === 6 && p >= 110000 && p <= 855999;
      },
      sanitize: function (v) { return (v || '').replace(/\D/g, '').slice(0, 6); },
      getCachedLocation: function () {
        try {
          var c = localStorage.getItem(CONFIG.LOCATION_CACHE_KEY);
          if (!c) { return null; }
          var d = JSON.parse(c);
          if (Date.now() - d.timestamp > CONFIG.LOCATION_CACHE_TTL) {
            localStorage.removeItem(CONFIG.LOCATION_CACHE_KEY);
            return null;
          }
          return d;
        } catch (e) { return null; }
      },
      setCachedLocation: function (pin, loc, deliveryDate) {
        try {
          localStorage.setItem(CONFIG.LOCATION_CACHE_KEY, JSON.stringify({
            pincode: pin, locationName: loc, deliveryDate: deliveryDate || '', timestamp: Date.now()
          }));
        } catch (e) {}
      }
    };

    function getISTDecimalHour() {
      var now = new Date();
      var ist = new Date(now.getTime() + now.getTimezoneOffset() * 60000 + 5.5 * 3600000);
      return ist.getHours() + ist.getMinutes() / 60;
    }

    function getZapprMessage() {
      var h = getISTDecimalHour();
      if (h >= CONFIG.ZAPPR_START_HOUR && h < CONFIG.ZAPPR_END_HOUR) {
        return { type: 'zappr_60min', showBike: true };
      }
      if (h >= CONFIG.ZAPPR_EARLY_START && h < CONFIG.ZAPPR_START_HOUR) {
        return { type: 'zappr_today', showBike: false,
                 text: '🌅 Order now and get delivery by 11:00 AM today.', color: '#2e7d32' };
      }
      return { type: 'zappr_tomorrow', showBike: false,
               text: '📦 Order now — your order will be delivered tomorrow by 11:00 AM.', color: '#555' };
    }

    /* ── bike animation ─────────────────────────────────────────── */
    var BikeAnim = (function () {
      var BIKE_URL = 'https://cdn.shopify.com/s/files/1/0562/1137/4249/files/delivery-bike.png?v=1773145015';
      var DURATION = 2000;

      var rafId = null, startTime = null;
      var bCanvas = null, bCtx = null;
      var bikeImg = null, textEl = null, stageEl = null;
      var stageW = 0, stageH = 0, bikeW = 0, bikeH = 40;
      var pool = [], lastSpawn = 0;

      var reduced = window.matchMedia &&
                    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var _png = new Image();
      _png.crossOrigin = 'anonymous';
      _png.src = BIKE_URL;

      function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

      function spawn(x, y, now) {
        if (now - lastSpawn < 48) { return; }
        lastSpawn = now;
        for (var i = 0; i < 2; i++) {
          pool.push({
            x: x + (Math.random() - 0.5) * 4,
            y: y + (Math.random() - 0.5) * 3,
            vx: -0.8 - Math.random() * 0.9,
            vy: -0.2 - Math.random() * 0.4,
            r: 1.2 + Math.random() * 1.4,
            life: 1.0,
            decay: 0.022 + Math.random() * 0.018
          });
        }
      }

      function tickSmoke() {
        if (!bCtx) { return; }
        for (var i = pool.length - 1; i >= 0; i--) {
          var p = pool[i];
          p.x += p.vx; p.y += p.vy; p.r += 0.22; p.life -= p.decay;
          if (p.life <= 0) { pool.splice(i, 1); continue; }
          bCtx.save();
          bCtx.globalAlpha = p.life * 0.26;
          var g = bCtx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
          g.addColorStop(0, '#aaa'); g.addColorStop(1, 'transparent');
          bCtx.fillStyle = g;
          bCtx.beginPath(); bCtx.arc(p.x, p.y, p.r, 0, Math.PI * 2); bCtx.fill();
          bCtx.restore();
        }
      }

      function frame(now) {
        if (!startTime) { startTime = now; }
        var t = Math.min((now - startTime) / DURATION, 1);
        var left = (-bikeW - 10) + ease(t) * (stageW + bikeW + 20);

        spawn(left + bikeW * 0.1, stageH - 8, now);
        bCtx.clearRect(0, 0, stageW, stageH);
        tickSmoke();

        if (bikeImg) { bikeImg.style.left = left.toFixed(1) + 'px'; }

        var revealed = Math.max(0, Math.min(1, (left + bikeW) / stageW));
        textEl.style.clipPath = 'inset(0 ' + ((1 - revealed) * 100).toFixed(2) + '% 0 0)';

        if (t < 1) {
          rafId = requestAnimationFrame(frame);
        } else {
          textEl.style.clipPath = 'none';
          if (bikeImg) { bikeImg.remove(); }
          if (bCanvas) { bCanvas.remove(); }
          if (stageEl) { stageEl.classList.add('done'); }
          pool.length = 0;
          rafId = null;
        }
      }

      function launch(msgEl, msgHTML) {
        stop();

        if (reduced) {
          msgEl.innerHTML = '<div class="pc-bike-stage done"><div class="pc-bike-text">' + msgHTML + '</div></div>';
          return;
        }

        pool.length = 0; lastSpawn = 0; startTime = null;

        msgEl.innerHTML =
          '<div class="pc-bike-stage">' +
            '<canvas class="pc-bike-canvas"></canvas>' +
            '<div class="pc-bike-text">' + msgHTML + '</div>' +
            '<img class="pc-bike-img" src="' + BIKE_URL + '" alt="" draggable="false" />' +
          '</div>';

        stageEl = msgEl.querySelector('.pc-bike-stage');
        bCanvas = msgEl.querySelector('.pc-bike-canvas');
        bCtx    = bCanvas.getContext('2d');
        textEl  = msgEl.querySelector('.pc-bike-text');
        bikeImg = msgEl.querySelector('.pc-bike-img');

        stageW = stageEl.offsetWidth  || 400;
        stageH = stageEl.offsetHeight || 48;
        bikeH  = bikeImg.offsetHeight || 40;
        bCanvas.width  = stageW;
        bCanvas.height = stageH;

        function go() {
          var aspect = (_png.naturalWidth && _png.naturalHeight)
            ? _png.naturalWidth / _png.naturalHeight : 1.9;
          bikeW = Math.round(bikeH * aspect);
          bikeImg.style.left = (-bikeW - 10) + 'px';
          rafId = requestAnimationFrame(frame);
        }

        if (_png.complete && _png.naturalWidth) { go(); }
        else { _png.onload = go; _png.onerror = go; }
      }

      function stop() {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        if (bCtx && bCanvas) { bCtx.clearRect(0, 0, bCanvas.width, bCanvas.height); }
        pool.length = 0;
        bikeImg = null;
      }

      return { launch: launch, stop: stop };
    })();

    /* ── UI ─────────────────────────────────────────────────────── */
    function showMessage(text, type) {
      el.msg.textContent = text;
      el.msg.style.fontWeight = (type === 'success' || type === 'error') ? '600' : '400';
      el.msg.style.color =
        type === 'error'   ? 'var(--pc-error)'   :
        type === 'success' ? 'var(--pc-success)' : 'var(--pc-muted)';
    }

    function showAutoLocation(pincode, locationName) {
      isAutoDetected = true;
      el.input.value = pincode;
      el.locationBadge.classList.add('active');
      el.locationText.classList.add('active');
      el.locationText.textContent = locationName;
      el.input.classList.add('with-badge');
    }

    function clearAutoLocation() {
      isAutoDetected = false;
      el.locationBadge.classList.remove('active');
      el.locationText.classList.remove('active');
      el.locationText.textContent = '';
      el.input.classList.remove('with-badge');
      el.input.classList.add('editable');
      el.input.value = '';
      el.msg.textContent = '';
      lastChecked = '';
      BikeAnim.stop();
    }

    /* ── serviceability list, one fetch per page ────────────────── */
     /* ── serviceability list, one fetch per page ────────────────── */
    /* CHANGED: resolve to null when the engine has not been parsed yet (a pincode
       typed within the first seconds of a slow load). checkPincode already treats
       null data as "clear the message and allow a retry". */
    function loadPincodeData() {
      return window.YHLPincode ? window.YHLPincode.loadData() : Promise.resolve(null);
    }
    function logSearch(pincode, resultType, wasAuto) {
      if (!CONFIG.ENABLE_SHEET_LOGGING) { return; }
      if (wasAuto) { return; }

      var key = pincode + '|' + resultType;
      if (sentKeys[key]) { return; }
      sentKeys[key] = true;

      try {
        var payload = {
          timestamp:       new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }),
          pincode:         pincode,
          resultType:      resultType,
          browserId:       utils.getBrowserId(),
          pageTitle:       document.title || 'Unknown',
          pageUrl:         window.location.pathname,
          detectionMethod: 'Manual Entry'
        };
        fetch(CONFIG.WEBHOOK_URL + '?' + new URLSearchParams(payload).toString(),
              { method: 'GET', mode: 'no-cors', keepalive: true }).catch(function () {});
      } catch (e) {}
    }

    /* ── main check ─────────────────────────────────────────────── */
    function checkPincode(pin, wasAuto) {
      pin = utils.sanitize(pin);

      if (pin.length !== 6) {
        if (!wasAuto) { showMessage('❌ Invalid Pincode', 'error'); }
        return Promise.resolve();
      }
      if (pin === lastChecked) { return Promise.resolve(); }
      lastChecked = pin;

      return loadPincodeData().then(function (data) {
        /* Guard: if the serviceability data failed to load, both sets are empty.
           Clear the message rather than showing a false negative. */
        if (!data || !data.shipRocket || (data.shipDelight.size + data.shipRocket.size) === 0) {
          el.msg.textContent = '';
          lastChecked = '';
          return;
        }
        var isMH = utils.isMaharashtra(pin);

        var _locationLabel = (el.locationText && el.locationText.textContent && el.locationText.textContent.trim())
          ? el.locationText.textContent.trim()
          : 'your location';

        function deliverAndCache(date) {
          showDeliverRow(_locationLabel, date);
          utils.setCachedLocation(pin, _locationLabel, date);
        }

        if (data.zappr.has(pin)) {
          var zi = getZapprMessage();
          deliverAndCache(calcDeliveryDate(0));
          if (zi.showBike) {
            BikeAnim.launch(el.msg,
              '<span class="pc-lightning">⚡</span>' +
              '<span>Express Delivery — Get your order within <strong>60 minutes!</strong></span>');
          } else {
            showMessage(zi.text, 'success');
            el.msg.style.color = zi.color;
          }
          logSearch(pin, 'Zappr - ' + zi.type, wasAuto);

        } else if (data.shipDelight.has(pin)) {
          deliverAndCache(calcDeliveryDate(2));
          showMessage(isMH
            ? '✅ Will be delivering within 1-2 business days'
            : '✅ Estimated delivery time: 1-2 business days', 'success');
          logSearch(pin, isMH ? 'Ship Delight - Maharashtra' : 'Ship Delight', wasAuto);

        } else if (data.shipRocket.has(pin)) {
          deliverAndCache(calcDeliveryDate(5));
          showMessage(isMH
            ? '✅ Will be delivering within 3-5 business days'
            : '✅ Delivering in 4-5 business days', 'success');
          logSearch(pin, isMH ? 'Ship Rocket - Maharashtra' : 'Ship Rocket', wasAuto);

        } else {
          /* Not serviceable. If this pincode was guessed from IP rather than
             typed, say nothing and let the visitor enter their own. A wrong
             guess must never tell a real customer we cannot deliver. */
          if (wasAuto && !CONFIG.SHOW_NEGATIVE_ON_AUTO) {
            clearAutoLocation();
            return;
          }
          showMessage('❌ Non serviceable pincode', 'error');
          logSearch(pin, 'Non Serviceable', wasAuto);
        }
      });
    }

    /* ── IP geolocation, three providers, one call per page ─────── */
    function applyDetected(result, prefix) {
      if (!result || !result.pincode) { el.msg.textContent = ''; return; }
      var label = (prefix || '') + (result.locationName || 'Your Location');
      showAutoLocation(result.pincode, label);
      utils.setCachedLocation(result.pincode, label);
      checkPincode(result.pincode, true);
    }

    function runDetection() {
      var cached = utils.getCachedLocation();
      if (cached) { applyDetected(cached, ''); return; }

      window.YHLPincode.detect().then(function (r) {
        if (r && r.pin) { applyDetected({ pincode: r.pin, locationName: r.locationName || '' }, '~'); }
        else            { el.msg.textContent = ''; }
      });
    }

    /* ── events ─────────────────────────────────────────────────── */
    el.inputWrap.addEventListener('click', function (e) {
      if (isAutoDetected && e.target !== el.btn && !el.btn.contains(e.target)) {
        clearAutoLocation();
        el.input.focus();
      }
    });

    el.input.addEventListener('focus', function () {
      if (isAutoDetected) { clearAutoLocation(); }
    });

    el.input.addEventListener('input', function (e) {
      var d = utils.sanitize(e.target.value);
      e.target.value = d;
      if (!el.input.classList.contains('editable')) { el.input.classList.add('editable'); }
      if (d.length < 6) { el.msg.textContent = ''; lastChecked = ''; BikeAnim.stop(); return; }
      checkPincode(d, false);
    });

    el.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); checkPincode(el.input.value, false); }
    });

    el.btn.addEventListener('click', function () { checkPincode(el.input.value, false); });

    /* ── init ───────────────────────────────────────────────────── */
    if (window.YHLPincode) { loadPincodeData(); }

    /* Synchronously restore cached deliver-row BEFORE any setTimeout — prevents
       the pincode input from flashing visible when the liquid block is replaced
       on variant change (theme.js ProductRerender replaces the full DOM node;
       the 300ms setTimeout below fires after the browser has already painted). */
    (function () {
      var c = utils.getCachedLocation();
      if (!c || !elDeliver.row || !elDeliver.location) { return; }
      elDeliver.location.textContent = c.locationName || c.pincode || '';
      elDeliver.date.textContent = c.deliveryDate || '';
      elDeliver.row.classList.add('visible');
      root.style.display = 'none';
      /* Collapse block-item margins immediately — same as showDeliverRow does —
         so no extra gap appears while waiting for runDetection to complete. */
      var blockItem = wrapper.closest('.product-info__block-item');
      if (blockItem) {
        blockItem.style.marginTop    = '0';
        blockItem.style.marginBottom = '0';
        blockItem.style.paddingTop   = '0';
        blockItem.style.paddingBottom= '0';
      }
    })();

    /* CHANGED: the engine (window.YHLPincode) is rendered once at the end of body.
       On a slow parse this timer fired before that script existed and runDetection
       threw on YHLPincode.detect, so auto-detect silently never ran. Wait for the
       engine when it is not there yet; if the document has already finished
       parsing without it, there is no engine to wait for. */
    setTimeout(function () {
      if (window.YHLPincode) { runDetection(); return; }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runDetection, { once: true });
      }
    }, 300);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-pincode-widget]');
    for (var i = 0; i < list.length; i++) initWidget(list[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
